import { Box, Typography } from "@mui/material";
import { CategoryCardProps } from "../models";

function CategoryCard({
  id,
  bgImg,
  title,
  storeNum,
  description,
  size,
  handleClick,
}: CategoryCardProps) {
  return (
    <Box
      position="relative"
      maxWidth={size ?? "150px"}
      maxHeight={size ?? "150px"}
      width={size && size}
      height={size && size}
      boxSizing="border-box"
      onClick={() => {
        if (handleClick) {
          handleClick(id);
        }
      }}
    >
      <Box
        component="img"
        width="100%"
        height="100%"
        src={bgImg ?? "/image-holder.png"}
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        height="100%"
        width="100%"
        boxSizing="border-box"
        sx={{
          backgroundImage:
            "linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(7, 7, 7, 0.3), rgba(82, 82, 82, 0) 97%, rgba(84, 84, 84, 0))",
        }}
      >
        <Box
          position="absolute"
          bottom="7%"
          padding="0 7%"
          width="100%"
          boxSizing="border-box"
          textAlign="center"
        >
          <Typography
            textAlign="center"
            fontSize="16px"
            lineHeight="25.5px"
            letterSpacing=".3px"
            fontWeight="600"
            color="white"
          >
            {title}
          </Typography>
          <Typography
            textAlign="center"
            fontSize="14px"
            lineHeight="16.8px"
            letterSpacing="0.6px"
            fontWeight="bold"
            color="white"
          >
            {storeNum ? storeNum.toLocaleString() : 0}{" "}
            <span
              style={{
                fontSize: "11px",
                lineHeight: "13.2px",
                letterSpacing: ".3px",
                fontWeight: "normal",
              }}
            >
              件
            </span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default CategoryCard;
